import { useApi } from '@/api';
import { KpiCard, Page, PageSkeleton, WalletCard } from '@/components';
import { Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import HistoricChart from './HistoricChart';
import { tokensMappingArbitrum } from '@/utils/tokens';
import DepositorEventsTable from './DepositorEventsTable';

export default function PSM3DepositorEventsPage() {
  const { walletAddress } = useParams();
  const [data, error] = useApi({
    url: `/arbitrum/psm3/depositors/${walletAddress}/`
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Page title={<Heading size="1">Wallet</Heading>}>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <WalletCard
            address={walletAddress}
            options={{
              network: 'arbitrum'
            }}
          />
        </Flex>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="USDS Balance"
            data={data}
            variant={'USDS'}
            field="usds_balance"
            options={{
              currency: tokensMappingArbitrum('USDS')
            }}
          />

          <KpiCard
            title="sUSDS Balance"
            data={data}
            variant={'sUSDS'}
            field="susds_balance"
            options={{
              currency: tokensMappingArbitrum('sUSDS')
            }}
          />

          <KpiCard
            title="USDC Balance"
            data={data}
            field="usdc_balance"
            options={{
              currency: tokensMappingArbitrum('USDC')
            }}
          />
        </Flex>

        <HistoricChart />
        <DepositorEventsTable walletAddress={walletAddress} />
      </Page>
    );
  }
  return <PageSkeleton />;
}
